import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import {
  Button,
  Icon,
  IconButton,
  TooltipContent,
  TooltipRoot,
  TooltipTrigger,
} from '@socialchorus/shared-ui-components';
import { uiOperations } from '../../../models/ui';
import { ID as ARCHIVE_CONFIRM_DIALOG_ID } from './archive-confirm-dialog';

interface ContentActionArchiveProps {
  contentId: number;
  wideMode?: boolean;
  container?: HTMLElement | null;
}

const ContentActionArchive = ({
  contentId,
  wideMode = false,
  container,
}: ContentActionArchiveProps) => {
  const { t } = useTranslation(undefined, { useSuspense: false });
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(
      uiOperations.displayOverlay(ARCHIVE_CONFIRM_DIALOG_ID, { contentId })
    );
  };

  const actionLabel = t('content_submission.archive', 'Archive');

  return wideMode ? (
    <Button
      onClick={handleClick}
      variant="text"
      size="compact"
      aria-label={actionLabel}
      leftIcon={<Icon>archive</Icon>}
      label={actionLabel}
    />
  ) : (
    <TooltipRoot>
      <TooltipTrigger asChild>
        <IconButton
          aria-label={actionLabel}
          iconName="archive"
          onClick={handleClick}
        />
      </TooltipTrigger>
      <TooltipContent description={actionLabel} container={container} />
    </TooltipRoot>
  );
};

export default ContentActionArchive;
